const rmsApiProxyRetry = require('../../../../utils/api/rmsApiProxyRetry');
const dateUtil = require('../../../../utils/dateUtil/dateUtil.js');
const guidUtil = require('../../../../utils/guid/guidUtil');
const stringUtil = require('../../../../utils/string/stringUtil');
const staffUtility = require('../../../../utils/domain/staff/staffUtility');
const constants = require('../../../../utils/domain/constants');

export function getSnoozes(selectedDispatchTypes, selectedVenueCodes, selectedChannels, selectedHours)
{
    let newSnoozeDetails = [];

    selectedDispatchTypes = Array.from(selectedDispatchTypes);
    selectedVenueCodes = Array.from(selectedVenueCodes);
    selectedChannels = Array.from(selectedChannels);
    
    if(selectedDispatchTypes.length === 0)
        selectedDispatchTypes.push(null);
    if(selectedVenueCodes.length === 0)
        selectedVenueCodes.push(null);
    if(selectedChannels.length === 0)
        selectedChannels.push(null);

    const operator = staffUtility.getStaffCompleteName(staffUtility.getLoginStaff());
    const dateTime = dateUtil.getNow();
    const expiry = calculateExpiry(selectedHours);

    selectedDispatchTypes.forEach(dispatchType =>
    {
        selectedVenueCodes.forEach(venueCode =>
        {
            selectedChannels.forEach(channel => 
            {
                newSnoozeDetails.push(
                    {
                        primaryId: guidUtil.generateGuid(),
                        type: constants.SnoozeTypes.property,
                        isSnoozed: true,
                        operator,
                        dateTime,
                        expiry,
                        channel,
                        venueCodes: venueCode ? [venueCode] : [],
                        dispatchTypes: dispatchType ? [dispatchType] : []
                    }
                )
            })
        })
    })

    return newSnoozeDetails;
}

export async function savePropertySnoozes(snoozes)
{
    const resource = `${rmsApiProxyRetry.getOrgContextToUrl()}/snooze`;
    const updateActiveSnoozeDetails = await rmsApiProxyRetry.post(resource, snoozes);

    return updateActiveSnoozeDetails;     ;   
}

function calculateExpiry(hours)
{
    if (stringUtil.isStringNullOrEmpty(hours) || hours == 0)
        return;

    return dateUtil.addHours(dateUtil.getNow(), hours);
}